export default {
	title: "Dashboard",
	description: "Overview of the system's status.",
	lastUpdated: "Last updated: {{date}}",
	noDate: "No date",
	summaryCards: {
		feedAmount: "Feed Amount",
		seaTemp: "Avg. sea temp",
		airTemp: "Avg. air temp",
		oxygen: "Oxygen",
		salinity: "Salinity",
		wind: "Wind",
		readings: "Data readings",
	},
	detail: {
		population: {
			cullCount: "Cull",
			mortalityCount: "Mortality",
			populationCount: "Population",
		},
		types: {
			oxygen: "Oxygen",
			depth: "Depth",
			temperature: "Temperature",
			salinity: "Salinity",
		},
	},
	filter: {
		allSites: "All sites",
		allUnits: "All units",
		addSecondSite: "Add second site",
	},
	badges: {
		feeding: "Feeding",
		offline: "Offline",
		stopped: "Stopped",
		noData: "No data",
		active: "Active",
		unknown: "Unknown",
	},
	sortOptions: {
		name: "Name",
		biomass: "Biomass",
		activity: "Activity",
		feeding: "Feeding",
	},
	filterOptions: {
		all: "All ({{value}})",
		active: "Active ({{value}})",
		feeding: "Feeding ({{value}})",
		alarms: "Alarms ({{value}})",
	},
	dataTypes: {
		error: {
			title: "Error",
			description: "Failed to load data type data."
		}
	},
	population: {
		error: {
			title: "Error",
			description: "Failed to load population data"
		}
	},
	feed: {
		intensity: "Intensity",
		feedAmount: "Feed Amount",
		recommendedFeedAmount: "Recommended Feed Amount",
		noData: "No feed data available",
		overflow: "Feed overflow",
		error: {
			title: "Error",
			description: "Failed to load feed data."
		}
	},
	buttons: {
		search: "Search",
		units: "Units",
		sites: "Sites",
		hideGraphics: "Hide Graphics",
		showGraphics: "Show Graphics",
		preferences: "Preferences",
		back: "Back to {{value}}",
		backToMultipleSites: "Back to sites",
		sortBy: "Sort by:",
		addNewView: "Add new view",
		closeView: "Close view",
	},
	loading: {
		liveView: {
			sites: "Loading sites...",
			units: "Loading units...",
		},
	},
	errors: {
		liveView: {
			sites: {
				title: "Error loading sites {{value}}",
				description: "Something went wrong while loading the sites. Please try again later or with a different company.",
			},
			units: {
				title: "Error loading units {{value}}",
				description: "Something went wrong while loading the units. Please try again later or with a different site.",
			}
		}
	}
};
